'use strict';

angular.module('theme').service('SsnSvService', function () {

	var invalid = {
		valid: false,
		sex: false,
		company: false,
		formatted: undefined
	};

	return function ssnService(value) {

		// Check for nulls and false lengths
		if (!value || value.length < 10) {
			return invalid;
		}

		// Remove dash and plus
		value = value.replace(' ', '').replace('-', '').replace('+', '');


		var century = '';
		// Remove century and check number
		if (value.length === 12) {
			century = value.substring(0, 2);
			value = value.substr(2, 10);
		} else if (value.length === 10) {
			value = value.substr(0, 10);
		} else {
			return invalid;
		}
		// Remove check number
		var check = parseInt(value.substr(9, 1), 10);
		var checkValue = value.substr(0, 9);

		var result = 0;

		// Calculate check number
		for (var i = 0, len = checkValue.length; i < len; i++) {
			var tmp = parseInt(checkValue.substr(i, 1), 10);

			if ((i % 2) === 0) {
				tmp = (tmp * 2);
			}

			if (tmp > 9) {
				result += (1 + (tmp % 10));
			} else {
				result += tmp;
			}
		}

		var isSSN = (parseInt(value.substr(2, 2), 10) < 13) && (parseInt(value.substr(4, 2), 10) < 32);

		// Only allow ssn's with 12 chars
		if (isSSN && !century) {
			var ageLimit = 110;
			var now = new Date().getFullYear();
			var ssnYear = parseInt('19' + value.substr(0, 2), 10);
			if ((now - ssnYear) >= ageLimit) {
				century = '20';
			} else {
				century = '19';
			}
		}

		return {
			valid: (((check + result) % 10) === 0),
			sex: ((parseInt(value.substr(8, 1), 10) % 2) === 0) ? 'female' : 'male',
			ssn: isSSN,
			coOrdinationNumber: (parseInt(value.substr(4, 2), 10) >= 60),
			company: (parseInt(value.substr(2, 2), 10) >= 20),
			formatted: (century + value.substr(0, 6) + '-' + value.substr(6, 4))
		};
	};

});
